import { render, staticRenderFns } from "./companySwiper.vue?vue&type=template&id=b66ccace&scoped=true"
import script from "./companySwiper.vue?vue&type=script&lang=js"
export * from "./companySwiper.vue?vue&type=script&lang=js"
import style0 from "./companySwiper.vue?vue&type=style&index=0&id=b66ccace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ccace",
  null
  
)

export default component.exports